import React from "react";
import { capacityForBookingDate, isBookingCapacityResolved } from "../../utils/bookingHelpers";

const DAY_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function BookingCard({
  safeEvent,
  selectedDate,
  calendarMonthLabel,
  onPrevMonth,
  onNextMonth,
  calendarCells,
  toYmd,
  isDateAllowed,
  monthLoading,
  monthAvailableDates,
  setSelectedDate,
  setCheckError,
  setAvailabilityMeta,
  setIsDateAvailable,
  setSelectedTimeSlot,
  isTable,
  timeSlots,
  slotAvailability,
  selectedTimeSlot,
  monthCapacityByDate,
  loadedMonthYm = "",
  bookingMaxCapacity = 0,
  toShortDateLabel,
  isFixedSingleEventDate = false,
  fixedEventDateLabel = "",
}) {
  const selectedDateLabel = selectedDate ? toShortDateLabel(selectedDate) : "Select Date";

  return (
    <>
      <div className="booking-topbar">
        <div className="booking-topbar-left" title={String(safeEvent?.address || "")}>
          <span className="booking-topbar-icon" aria-hidden>
            ⊙
          </span>
          <span className="booking-topbar-text">{safeEvent?.address || "Address not available"}</span>
        </div>
        <div className="booking-topbar-right">
          <span className="booking-topbar-icon" aria-hidden>
            ⌁
          </span>
          <span className="booking-topbar-text">
            {isFixedSingleEventDate ? fixedEventDateLabel : selectedDateLabel}
          </span>
        </div>
      </div>

      {isFixedSingleEventDate ? (
        <div className="booking-fixed-date-wrap">
          <span className="booking-label">Event Date</span>
          <p className="booking-fixed-date">{fixedEventDateLabel}</p>
        </div>
      ) : (
        <>
          <div className="booking-top-row">
            <span className="booking-label">Select Date</span>
            <span className="booking-month-nav">
              <button type="button" onClick={onPrevMonth}>
                {"<"}
              </button>
              <strong>{calendarMonthLabel}</strong>
              <button type="button" onClick={onNextMonth}>
                {">"}
              </button>
            </span>
          </div>

          <div className="booking-calendar">
            {DAY_SHORT.map((d) => (
              <div key={d} className="booking-weekday">
                {d}
              </div>
            ))}
            {calendarCells.map((cell, idx) => {
              if (!cell) return <div key={`empty-${idx}`} className="booking-day empty" />;
              const ymd = toYmd(cell);
              const active = selectedDate === ymd;
              const allowed = isDateAllowed(cell);
              const availableInApi =
                !monthLoading && Object.keys(monthAvailableDates).length > 0
                  ? Boolean(monthAvailableDates[ymd])
                  : true;
              return (
                <button
                  key={ymd}
                  type="button"
                  disabled={!allowed || !availableInApi}
                  className={`booking-day ${active ? "active" : ""}`}
                  onClick={() => {
                    setSelectedDate(ymd);
                    setCheckError("");
                    setAvailabilityMeta("Checking availability...");
                    setIsDateAvailable(true);
                    setSelectedTimeSlot("");
                  }}
                >
                  {cell.getDate()}
                </button>
              );
            })}
          </div>
        </>
      )}

      {isTable ? (
        <div className="booking-time-wrap">
          <p className="booking-section-title">Select available time slot</p>
          <div className="booking-slots">
            {timeSlots.map((slot) => (
              <button
                key={slot.value}
                type="button"
                className={`booking-slot-btn ${selectedTimeSlot === slot.value ? "active" : ""} ${
                  slotAvailability[slot.value] === false ? "unavailable" : ""
                }`}
                disabled={slotAvailability[slot.value] === false}
                onClick={() => setSelectedTimeSlot(slot.value)}
              >
                {slotAvailability[slot.value] === false ? `${slot.label} (Unavailable)` : slot.label}
              </button>
            ))}
          </div>
        </div>
      ) : selectedDate ? (
        <div className="booking-time-wrap">
          <p className="booking-section-title">Date Availability</p>
          <div className="booking-availability-grid">
            {(() => {
              const cap = capacityForBookingDate(
                selectedDate,
                monthCapacityByDate,
                monthLoading,
                bookingMaxCapacity,
                loadedMonthYm
              );
              const resolved = isBookingCapacityResolved(
                selectedDate,
                monthLoading,
                loadedMonthYm,
                monthCapacityByDate
              );
              const soldOut = resolved && cap != null && cap <= 0;
              return (
                <div key={`avl-${selectedDate}`} className={`booking-avl-card active ${soldOut ? "soldout" : ""}`}>
                  <span className="booking-avl-date">{toShortDateLabel(selectedDate)}</span>
                  <span className="booking-avl-cap">
                    {!resolved
                      ? "Checking..."
                      : soldOut
                        ? "Sold Out"
                        : `Avl: ${cap}`}
                  </span>
                </div>
              );
            })()}
          </div>
        </div>
      ) : null}
    </>
  );
}
